<template>
  <component :is="skeletonComponent" v-bind="$attrs" />
</template>

<script setup lang="ts">
import TaskSkeletonList from './components/tasks/taskList.vue'
import ShopSkeletonList from './components/shop/shopList.vue'
import NotificationsSkeletonList from './components/notifications/index.vue'
import PurchaseSkeletonList from './components/purchases/purchaseList.vue'
import RatingsSkeleton from './components/ratings/index.vue'
import BattlepassSkeleton from './components/battlepass/index.vue'
import UiSkeleton from './components/list.vue'
import SquadsListSkeleton from './components/squads/squadsList.vue'
import SquadLogsSkeleton from './components/squads/squadLogs.vue'
import RacesAllSkeleton from './components/squads/racesAll.vue'
import RacePageWrapperSkeleton from './components/squads/racePageWrapper.vue'
import SquadMeSkeleton from './components/squads/squadMe.vue'
import RaceCardSkeleton from './components/squads/raceCard.vue'
import SquadPageSkeleton from './components/squads/squadPage.vue'
import PickemAllTournaments from './components/pickem/all.vue'
import FantasyAll from './components/fantasy/all.vue'

defineOptions({
  name: 'CommonSkeleton',
  inheritAttrs: false
})

const props = withDefaults(
  defineProps<{
    type?:
      | 'default'
      | 'task-list'
      | 'shop-list'
      | 'notification-list'
      | 'purchases-list'
      | 'ratings'
      | 'battlepass'
      | 'squads-list'
      | 'squad-logs'
      | 'races-all'
      | 'race-page-wrapper'
      | 'squad-me'
      | 'race-card'
      | 'squad-page'
      | 'pickem-all'
      | 'fantasy-all'
  }>(),
  {
    type: 'default'
  }
)

const skeletonComponent = computed(() => {
  switch (props.type) {
    case 'task-list':
      return TaskSkeletonList
    case 'shop-list':
      return ShopSkeletonList
    case 'notification-list':
      return NotificationsSkeletonList
    case 'purchases-list':
      return PurchaseSkeletonList
    case 'ratings':
      return RatingsSkeleton
    case 'battlepass':
      return BattlepassSkeleton
    case 'squads-list':
      return SquadsListSkeleton
    case 'squad-logs':
      return SquadLogsSkeleton
    case 'races-all':
      return RacesAllSkeleton
    case 'race-page-wrapper':
      return RacePageWrapperSkeleton
    case 'squad-me':
      return SquadMeSkeleton
    case 'race-card':
      return RaceCardSkeleton
    case 'squad-page':
      return SquadPageSkeleton
    case 'pickem-all':
      return PickemAllTournaments
    case 'fantasy-all':
      return FantasyAll
    default:
      return UiSkeleton
  }
})
</script>
